import React, { memo } from 'react';
export function ModulesSection() {
  const modules = [{
    title: "Capire la Memoria e l'Invecchiamento",
    description: 'Capire cosa è normale e cosa no. La neuroplasticità a ogni età.',
    transformation: 'Chiarezza e fiducia.'
  }, {
    title: 'Nutrizione per il Cervello',
    description: 'Mediterranea, omega-3, polifenoli, vitamine chiave. Ricette e piani settimanali.',
    transformation: 'Energia e lucidità a tavola.'
  }, {
    title: 'Esercizi Cognitivi (biblioteca + progressioni)',
    description: "Memoria breve/lunga, attenzione, linguaggio, creatività — dal facile all'avanzato.",
    transformation: 'Mente allenata e pronta a ricordare.'
  }, {
    title: 'Stile di Vita & Benessere Emotivo',
    description: 'Sonno, stress, movimento leggero, mindfulness, relazioni.',
    transformation: 'Serenità che protegge la memoria.'
  }, {
    title: 'Programma Completo di 8 Settimane',
    description: 'Piano quotidiano con obiettivi, esercizi, checklist, riflessioni e monitoraggio.',
    transformation: 'In 8 settimane autonomia e metodo sostenibile.'
  }];
  return <section id="programma" className="w-full bg-gray-50 py-20 px-4 sm:px-6 lg:px-8" data-id="element-126">
      <div className="max-w-5xl mx-auto" data-id="element-127">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6 text-center" data-id="element-128">
          I 5 moduli che trasformano la mente (e come lavorano insieme)
        </h2>
        <p className="text-lg sm:text-xl text-gray-700 mb-12 max-w-3xl mx-auto text-center" data-id="element-129">
          Ogni modulo agisce su un pilastro: conoscenza, nutrizione, stimolo,
          benessere, integrazione. Troverai video, PDF pratici, esercizi
          guidati, checklist e piano giorno-per-giorno.
        </p>
        <div className="space-y-6" data-id="element-130">
          {modules.map((module, index) => <div key={index} className="bg-white p-6 sm:p-8 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow" data-id="element-131">
              <div className="flex items-start space-x-4" data-id="element-132">
                <div className="flex-shrink-0 w-12 h-12 bg-green-600 text-white rounded-full flex items-center justify-center text-2xl font-bold" data-id="element-133">
                  {index + 1}
                </div>
                <div className="flex-1" data-id="element-134">
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3" data-id="element-135">
                    {module.title}
                  </h3>
                  <p className="text-lg text-gray-700 mb-3" data-id="element-136">
                    {module.description}
                  </p>
                  <p className="text-lg font-semibold text-green-700" data-id="element-137">
                    Trasformazione: {module.transformation}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}